import React, { useState } from "react";
import styled from "styled-components";
import PostInput from "./PostInput";
import { breakpoints } from "../styles/theme";
import { ReactComponent as NewIcon } from "../assets/icons/new.svg";

const NewPostButtonMobile: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <ButtonCircle onClick={handleOpen}>
        <NewIcon />
      </ButtonCircle>

      {isOpen && (
        <ModalOverlay onClick={handleClose}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <PostInput inModal />
          </ModalContent>
        </ModalOverlay>
      )}
    </>
  );
};

const ButtonCircle = styled.button`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgb(250, 250, 250);
  color: #000000;
  font-size: 32px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 90px;
  left: 50%; /* ← 画面中央 */
  transform: translateX(-50%); /* ← 自分の幅の半分だけ左にずらす */
  z-index: 20;
  border: none;
  cursor: pointer;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.05);
  svg {
    width: 28px;
    height: 28px;
    fill: #000; // 色を変えたい場合
  }

  @media (min-width: ${breakpoints.mobile}) {
    display: none;
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 30;
`;

const ModalContent = styled.div`
  background: #ffffff00;
  border-radius: 24px;
  width: 90%;
  max-width: 500px;
  padding: 20px;
`;

export default NewPostButtonMobile;
